import { Instagram as InstagramIcon, Twitter as TwitterIcon, Facebook as FacebookIcon, Globe as GlobeIcon } from '@transferwise/icons';
export default {
  globe: GlobeIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon
};